import React from "react";
import "./footer.css";

export default function Footer() {
  return (
    <div id="page-footer">
      <div className="legal-links">
        <a href="/terms-and-conditions" className="footer-link">
          Terms &amp; Conditions
        </a>
        <span style={{ color: "white" }}>|</span>
        <a href="/privacy" className="footer-link">
          Privacy Policy
        </a>
      </div>
      <div className="footer-copyright">© Gup&apos;s Corner</div>
    </div>
  );
}
